import { useQuery } from 'react-query'
import { superFetch } from 'commons'

export const useClient = () =>
  useQuery('client', () => superFetch({ url: 'organisation/nom' }), {
    staleTime: 86400000, // 1 DAY
  })
